import * as React from 'react';
import { useEffect, useState } from 'react';
import { Tabs } from '@mantine/core';
import { useParams, useSearchParams } from 'react-router-dom';
import { QueryBaseComponent } from '../../../../../react-commons/query/QueryBaseComponent';
import { WorkFlowRepresentationComponent } from './WorkFlowRepresentationComponent';
import { useProjectVersionActions } from '../../../resource/resources/artifacts/project/projectVersionResource';
import {
    useWorkflowRepresentationActions,
} from '../../../resource/resources/artifacts/use_case/representation/workflowRepresentationResource';
import { useUseCaseActions } from '../../../resource/resources/artifacts/use_case/useCaseResource';
import {
    useUseCaseWorkflowAssociationRepresentationActions,
} from '../../../resource/resources/artifacts/use_case/useCaseWorkflowRepresentationAssociationResource';

export const WorkFlowRepresentationsComponent = () => {
    const [activeTab, setActiveTab] = useState<string | null>(null);

    const { id: projectId, versionId, useCaseId, useCaseObjectId, workflowObjectId } = useParams<{
        id: string,
        versionId: string,
        useCaseId: string,
        useCaseObjectId: string,
        workflowObjectId: string
    }>();

    const [search, setSearch] = useSearchParams();

    const projectVersionActions = useProjectVersionActions()
    const workflowActions = useWorkflowRepresentationActions()
    const useCaseActions = useUseCaseActions()
    const useCaseRepresentationAssociationActions = useUseCaseWorkflowAssociationRepresentationActions()

    const projectVersionQuery = projectVersionActions.useGetByPublishment(search.get('publishment'), projectId);
    const useCaseQueryByObjectId = useCaseActions.useGetResourceByObjectIdAndVersionedIn(useCaseObjectId, versionId ?? projectVersionQuery.data?.id);
    const useCaseQueryById = useCaseActions.useGetResource(useCaseId);
    const workflowsQuery = workflowActions.useGetAllResources(versionId ?? projectVersionQuery.data?.id);
    const representationAssociationsQuery = useCaseRepresentationAssociationActions.useGetAllResources(useCaseId ?? useCaseQueryByObjectId.data?.id);

    const setActiveTabAndSelected = (value: string | null) => {
        setSearch((prevParams) => {
            if (value) {
                prevParams.set('selected', value);
            } else {
                prevParams.delete('selected');
            }
            return prevParams;
        });
        setActiveTab(value);
    };

    const filteredWorkflows = () => {
        const useCaseToWorkflowRefs = representationAssociationsQuery.data?.map(value => value.workflowRepresentation) ?? [];
        return workflowsQuery.data?.filter(value => useCaseToWorkflowRefs.includes(value.objectId)) ?? [];
    };

    useEffect(() => {
        if (workflowsQuery.data && representationAssociationsQuery.data && activeTab === null) {
            setActiveTab(search.get('selected') ?? filteredWorkflows().find(value => value.objectId === workflowObjectId)?.id ?? filteredWorkflows()[0]?.id ?? null);
        }
    }, [workflowsQuery, workflowsQuery.data, activeTab, search, representationAssociationsQuery, representationAssociationsQuery.data]);

    return (
        <div className={'main-window-content'}>
            <QueryBaseComponent name={'workflows'} query={workflowsQuery}>
                {filteredWorkflows().length === 1 ? (
                    <WorkFlowRepresentationComponent workflowResource={filteredWorkflows()[0]} inTabs={false}
                                                     useCaseObjectId={useCaseObjectId ?? useCaseQueryById.data?.objectId ?? ''} />
                ) : (
                    <Tabs keepMounted={false} value={activeTab} onChange={setActiveTabAndSelected} style={{ flexGrow: 1 }}>
                        <Tabs.List>
                            {filteredWorkflows().map(value => (
                                <Tabs.Tab key={value.id} value={value.id}>{value.name}</Tabs.Tab>
                            ))}
                        </Tabs.List>
                        {filteredWorkflows().map(value => (
                            <Tabs.Panel key={value.id} value={value.id}>
                                <WorkFlowRepresentationComponent workflowResource={value} inTabs={activeTab !== value.id ? undefined : true}
                                                                 useCaseObjectId={useCaseObjectId ?? useCaseQueryById.data?.objectId ?? ''} />
                            </Tabs.Panel>
                        ))}
                    </Tabs>
                )}
            </QueryBaseComponent>
        </div>
    );
};